module.exports = __webpack_public_path__ + "static/media/land.50d42199.svg";